import { __assign } from "tslib";
import { InvoiceItemBuilder } from './invoice-item-builder';
var InvoiceBuilder = /** @class */ (function () {
    function InvoiceBuilder() {
        this.invoice = {
            items: [new InvoiceItemBuilder().build()],
            total: { amount: '100', currency: 'EUR' },
            discount: undefined,
            tax: undefined,
            subTotal: { amount: '100', currency: 'EUR' },
            grandTotal: { amount: '100', currency: 'EUR' },
            revenue: { amount: '100', currency: 'EUR' },
            fees: [],
        };
    }
    InvoiceBuilder.prototype.withItems = function (items) {
        this.invoice.items = items;
        return this;
    };
    // TODO: deprecated in favor of grandTotal
    InvoiceBuilder.prototype.withTotal = function (total) {
        this.invoice.total = total;
        return this;
    };
    InvoiceBuilder.prototype.withSubTotal = function (subTotal) {
        this.invoice.subTotal = subTotal;
        return this;
    };
    InvoiceBuilder.prototype.withDiscount = function (discount) {
        this.invoice.discount = discount;
        return this;
    };
    InvoiceBuilder.prototype.withTax = function (tax) {
        this.invoice.tax = tax;
        return this;
    };
    InvoiceBuilder.prototype.withGrandTotal = function (grandTotal) {
        this.invoice.grandTotal = grandTotal;
        return this;
    };
    InvoiceBuilder.prototype.withRevenue = function (revenue) {
        this.invoice.revenue = revenue;
        return this;
    };
    InvoiceBuilder.prototype.withFee = function (fee) {
        this.invoice.fees.push(fee);
        return this;
    };
    InvoiceBuilder.prototype.build = function () {
        return __assign({}, this.invoice);
    };
    return InvoiceBuilder;
}());
export { InvoiceBuilder };
//# sourceMappingURL=invoice-builder.js.map